import { slicedToArray as _slicedToArray, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../node_modules/prop-types/index.js';
import React from 'react';
import classnames from '../../node_modules/classnames/index.js';
import { styled, useThemeProps, Fade } from '@mui/material';
import useElementVisibility$1 from '../../cinnamon-web/es/components/utility/useElementVisibility.js';
import { createComponentSlot } from '../../modules/styling/theme.js';

var componentRoot = createComponentSlot({
  name: "CinVirtualizedRow",
  slot: "Root"
});

var VirtualizedRowBase = function VirtualizedRowBase(_ref) {
  var children = _ref.children,
      visibleMargin = _ref.visibleMargin,
      _ref$disableTransitio = _ref.disableTransition,
      disableTransition = _ref$disableTransitio === void 0 ? false : _ref$disableTransitio,
      _ref$transitionCompon = _ref.transitionComponent,
      TransitionComponent = _ref$transitionCompon === void 0 ? Fade : _ref$transitionCompon,
      transitionProps = _ref.transitionProps,
      className = _ref.className,
      root = _ref.root;

  var _useElementVisibility = useElementVisibility$1({
    root: root,
    rootMargin: typeof visibleMargin === "number" ? "".concat(visibleMargin, "px 0px ").concat(visibleMargin, "px 0px") : undefined
  }),
      _useElementVisibility2 = _slicedToArray(_useElementVisibility, 2),
      ref = _useElementVisibility2[0],
      visible = _useElementVisibility2[1];

  var content = disableTransition ? visible && children : /*#__PURE__*/React.createElement(TransitionComponent, _extends({}, transitionProps, {
    in: visible,
    mountOnEnter: true,
    unmountOnExit: true
  }), children);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: classnames(componentRoot.className, className)
  }, content);
};

VirtualizedRowBase.propTypes = {
  children: propTypes.node,
  height: propTypes.oneOfType([propTypes.number, propTypes.string]),
  visibleMargin: propTypes.number,
  disableTransition: propTypes.bool,
  transitionComponent: propTypes.elementType,
  transitionProps: propTypes.any,
  className: propTypes.string,
  variant: propTypes.any,
  root: propTypes.oneOfType([propTypes.element, propTypes.any, propTypes.oneOf([null])])
};
var VirtualizedRowRoot = styled(VirtualizedRowBase, componentRoot.styledOptions)(function (_ref2) {
  var height = _ref2.height;
  return {
    height: height
  };
});
/**
 * A container for a row using virtualized rendering
 */

var VirtualizedRow = function VirtualizedRow(props) {
  var rootProps = useThemeProps({
    props: props,
    name: componentRoot.name
  });
  return /*#__PURE__*/React.createElement(VirtualizedRowRoot, rootProps);
};

var VirtualizedRow$1 = VirtualizedRow;

export { VirtualizedRow$1 as default };
